import * as React from 'react';
import { ViewFolderDto, t, AssetId } from '@deltasierra/shared';
import CollectionListItem from '../CollectionListItem';
import './CollectionList.scss';
import { Input } from '../../Input';

export type CollectionListProps = {
    title: string;
    collections: ViewFolderDto[];
    expiredCount: number;
    deletedCount: number;
    onClick: (collectionId: AssetId) => void;
    onClickExpired?: () => void;
    onClickDeleted?: () => void;
    selectedCollectionId?: number;
};

const CollectionList: React.FunctionComponent<CollectionListProps> = ({
    collections,
    onClick,
    selectedCollectionId,
    title,
}) => {
    const expiredAndDeletedListItems = (
        <div>
            {/* <hr />
            <CollectionListItem
                assetCount={deletedCount}
                icon={'deleted'}
                name={t('COMMON.DELETED')}
                onClick={onClickDeleted}
            />
            <CollectionListItem
                assetCount={expiredCount}
                icon={'expired'}
                name={t('COMMON.EXPIRED')}
                onClick={onClickExpired}
            /> */}
        </div>
    );

    const noCollectionMessage = () => {
        if (collections.length === 0) {
            return (
                <div
                    style={{
                        height: 50,
                        padding: 12,
                        textAlign: 'center',
                        width: '100%',
                    }}
                >
                    {t('COMMON.NO_MATCHING_COLLECTIONS_FOUND')}
                </div>
            );
        }
        return <div />;
    };

    return (
        <div className="well">
            <h3>{title}</h3>
            <div>
                {collections
                    // Show collections in alphabetical order
                    .sort((collection1, collection2) =>
                        collection1.title.toLowerCase().localeCompare(collection2.title.toLowerCase()),
                    )
                    .map(collection => (
                        <CollectionListItem
                            assetCount={collection.numChildren}
                            icon={collection.majorityChildType}
                            key={collection.id}
                            name={collection.title}
                            selected={collection.id === selectedCollectionId}
                            onClick={() => onClick(AssetId.from(collection.id))}
                        />
                    ))}
                {noCollectionMessage()}
                {expiredAndDeletedListItems}
            </div>
        </div>
    );
};

CollectionList.displayName = 'CollectionList';

export type FilteredCollectionListProps = Omit<CollectionListProps, 'title'> & {
    clientTitle: string;
    locationTitle: string;
};

export const FilteredCollectionList: React.FunctionComponent<FilteredCollectionListProps> = ({
    clientTitle,
    collections,
    deletedCount,
    expiredCount,
    locationTitle,
    onClick,
    onClickDeleted,
    onClickExpired,
    selectedCollectionId,
}) => {
    const [searchTerm, setSearchTerm] = React.useState<string>('');

    const filteredList = collections.filter(collection =>
        collection.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
    );

    return (
        <>
            <Input
                clearable
                placeholder={t('COMMON.FILTER_COLLECTIONS')}
                style={{ borderRadius: 3, marginBottom: 10, padding: 5, width: '100%' }}
                onTermChange={setSearchTerm}
            />
            <CollectionList
                collections={filteredList.filter(collection => collection.permissionLevel === 'client')}
                deletedCount={deletedCount}
                expiredCount={expiredCount}
                selectedCollectionId={selectedCollectionId}
                title={clientTitle}
                onClick={onClick}
                onClickDeleted={onClickDeleted}
                onClickExpired={onClickExpired}
            />
            <CollectionList
                collections={filteredList.filter(collection => collection.permissionLevel === 'location')}
                deletedCount={deletedCount}
                expiredCount={expiredCount}
                selectedCollectionId={selectedCollectionId}
                title={locationTitle}
                onClick={onClick}
                onClickDeleted={onClickDeleted}
                onClickExpired={onClickExpired}
            />
        </>
    );
};

export default CollectionList;
